module.exports = __webpack_public_path__ + "df308edbefd577bdfe46b85607a26424.png";